import { render, staticRenderFns } from "./QType3Answer.vue?vue&type=template&id=21fdb8d0&scoped=true&"
import script from "./QType3Answer.vue?vue&type=script&lang=js&"
export * from "./QType3Answer.vue?vue&type=script&lang=js&"
import style0 from "./QType3Answer.vue?vue&type=style&index=0&id=21fdb8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fdb8d0",
  null
  
)

export default component.exports